import Card from "components/card/custom";
import React, { useEffect } from "react";
import {
  createColumnHelper,
  flexRender,
  getCoreRowModel,
  getExpandedRowModel,
  getSortedRowModel,
  SortingState,
  useReactTable,
} from "@tanstack/react-table";
import { getBlackListHistoryById } from "api/blackListClient";
import { useDisclosure } from "@chakra-ui/hooks";
import {
  Modal,
  ModalBody,
  ModalFooter,
  ModalOverlay,
  ModalHeader 
} from "@chakra-ui/modal";
import DivLoader from "components/divloader/DivLoader";
import { toast } from "react-hot-toast";
import {
  MdHighlightOff,
  MdHistory,
} from "react-icons/md";
import InfoModal from "./InfoModal";
import moment from "moment";
import DatePicker from "react-datepicker";
import { BsArrowDown, BsArrowUp } from "react-icons/bs";
import { RiArrowUpDownFill } from "react-icons/ri";
import { Popover, PopoverTrigger, PopoverContent, PopoverHeader , PopoverArrow } from "@chakra-ui/react";
import { Portal } from '@chakra-ui/portal'

export interface iCreateOrgForm {
  first_name: string;
  last_name: string;
  bin: string;
  last_four: string;
  email: string;
  is_binAndlast_four?: any;
  is_client_name?: any;
  is_email?: any;
}
const ViewHistoryModal = ({
  fetchBlackListClientsData,
  id,
  info,
  roleData,
  infoData,
  tableData,
}: {
  fetchBlackListClientsData: () => void;
  id?: string;
  info?: boolean;
  roleData?: any;
  infoData?: any;
  tableData?: any;
}) => {
 

  const { isOpen, onOpen, onClose } = useDisclosure();
  const [isLoading, setIsLoading] = React.useState<boolean>();
  const [isCloseModal, setIsCloseModal] =  React.useState<boolean>(false);
  const [filterFormData, setFilterFormData] = React.useState<any>({});
  

  const [data, setData] = React.useState([]);
  const [allData, setAllData] = React.useState([]);

  const handleClose = () => {
    setData([]);
    setFilterFormData({});
    setIsCloseModal(true)
    setTimeout(() => {
      setIsCloseModal(false)
      onClose();
    }, 300);
  };

  async function fetchBlockedUserHistoryById(id: string) {
    setIsLoading(true);
    await getBlackListHistoryById(id)
      .then((data: any) => {
        setData(data);
        setAllData(data);
      })
      .catch((err: any) => {
        toast.error(err?.response?.data?.message ?? "Unable to fetch data");
      })
      .finally(() => {
        setIsLoading(false);
      });
  }

  useEffect(() => {
    if (filterFormData?.starting_date && filterFormData?.ending_date) {
      const filtered = allData?.filter((f: any) => {
        const createdDate = moment(f?.created_at).format("YYYY-MM-DD");
        const startDate = moment(filterFormData.starting_date).format("YYYY-MM-DD");
        const endDate = moment(filterFormData.ending_date).format("YYYY-MM-DD");
  
        return startDate <= createdDate && endDate >= createdDate;
      });
      setData(filtered);
    } else {
      setData(allData);
    }
  }, [filterFormData?.ending_date]);
  

  const columns = [
    columnHelper.accessor("client_name", {
      id: "client_name",
      header: () => (
        <p className="text-sm font-bold text-gray-900 dark:text-white">
          Client Name
        </p>
      ),
      sortDescFirst: true,
      cell: (info) => {
        return (
          <>
            {!info.row.getIsExpanded() && !info.row.getIsExpanded() && (
              <p className="text-sm font-bold text-navy-700 dark:text-white">
                {info.getValue()}
              </p>
            )}
          </>
        );
      },
    }),

    columnHelper.accessor("created_at", {
      id: "created_at",
      header: () => (
        <p className="text-sm font-bold text-gray-900 dark:text-white">
          Date & Time
        </p>
      ),
      sortDescFirst: true,
      cell: (info) => {
        return (
          <>
            {!info.row.getIsExpanded() && !info.row.getIsExpanded() && (
              <p className="text-sm font-bold text-navy-700 dark:text-white">
                {info.getValue()}
              </p>
            )}
          </>
        );
      },
    }),

    columnHelper.accessor("request", {
      id: "request",
      header: () => (
        <p className="text-sm font-bold text-gray-900 dark:text-white">
          Request
        </p>
      ),
      sortDescFirst: true,
      cell: (info) => {
        return (
          <>
            {true && (
              <p className="text-sm font-bold text-navy-700 dark:text-white">
                <InfoModal
                  heading={info?.row?.original?.client_name}
                  info={info.getValue()}
                />
              </p>
            )}
          </>
        );
      },
      enableSorting:false
    }),
  ];

  const table = useReactTable({
    data,
    columns: columns,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getExpandedRowModel: getExpandedRowModel(),
    debugTable: true,
  });

  return (
    <>
      {info
        ? roleData?.[0]?.blacklist?.value?.view_blacklist && (
          <>
            <Popover trigger="hover" placement="bottom">
              <PopoverTrigger>
                <div
                  onClick={() => {
                    if (id) {
                      fetchBlockedUserHistoryById(id);
                    }
                    onOpen();
                  }}
                >
                  {" "}
                  <MdHistory
                    className="h-5 w-5 cursor-pointer text-blue-500"
                  />
                </div>
              </PopoverTrigger>  
              <Portal > 
                <PopoverContent borderColor='blue.800' className="z-20 dark:bg-gray-800 shadow  invisible inline-block text-sm text-gray-500 transition-opacity duration-300 bg-white border border-gray-200 rounded-lg shadow-sm opacity-0 dark:text-gray-400 dark:border-gray-600 dark:bg-gray-800 p-3 border-6 shadow !bg-gray-700">
                  <PopoverHeader>
                    <span className="text-sm  font-bold text-white">
                  View History
                  </span>
                  </PopoverHeader>
                  <PopoverArrow  className="border h-8 w-8 border-gray-700 !bg-gray-700  "  />
                </PopoverContent>
              </Portal>
            </Popover>
          </>
            
          )
        : ""}
      <Modal isOpen={isOpen} onClose={() => {}}>
        <ModalOverlay className="bg-[#000] !opacity-30" />
        {/* <ModalContent className="sm:max-w-xxl scrollbarhide   z-[1002] !m-auto flex max-h-[100vh] min-h-[100vh] max-w-[800px]  justify-start overflow-auto sm:my-8 sm:w-full "> */}
        <Card extra={`fixed top-0 right-0 h-full rounded-none max-w-[600px] sm:w-full flex flex-col justify-start !z-[1004] overflow-y-auto scrollbar-hide overflow-auto ${
            isOpen && !isCloseModal ? "card-enter" : "card-exit"
          }`}>
          <ModalHeader className="py-[20px] mb-[20px] px-[30px] text-2xl font-bold bg-brand-500 text-white">
            <MdHighlightOff
              className="absolute right-7 top-6 h-8 w-8 cursor-pointer text-white"
              onClick={handleClose}
            />
            History
          </ModalHeader>
          <ModalBody className="p-2">
            
              <div className="px-3">
                <div className="">
                  <label className="mb-2 block text-sm font-medium text-gray-900 dark:text-white">
                    Date Range
                  </label>
                  {true && (
                    <DatePicker
                      className="w-full rounded border p-3 outline-none"
                      placeholderText="Select Date Range"
                      startDate={
                        filterFormData?.starting_date &&
                        new Date(filterFormData?.starting_date)
                      }
                      endDate={
                        filterFormData?.ending_date &&
                        new Date(filterFormData?.ending_date)
                      }
                      selectsRange={true}
                      isClearable={true}
                      onChange={(dateRange: any) => {
                        const [a, b] = dateRange;
                        setFilterFormData((prev: any) => {
                          return {
                            ...prev,
                            starting_date: a,
                            ending_date: b,
                          };
                        });
                      }}
                    />
                  )}
                </div>
                <div className="mt-3">
                  <p>
                    <span className="text-lg text-gray-900">
                      Result shown for Date Range:{" "}
                    </span>
                    {filterFormData?.starting_date &&
                    filterFormData?.ending_date ? (
                      <span className="rounded border px-2 text-lg text-gray-900">
                        {filterFormData?.starting_date &&
                          moment(filterFormData?.starting_date).format(
                            "YYYY-MM-DD"
                          )}{" "}
                        {" - "}{" "}
                        {filterFormData?.ending_date &&
                          moment(filterFormData?.ending_date).format(
                            "YYYY-MM-DD"
                          )}
                      </span>
                    ) : (
                      <span className="rounded border px-2 text-lg text-gray-900">
                        {"All"}
                      </span>
                    )}
                  </p>
                  <p className="text-end text-gray-900">Total Count : {data?.length ?? "0"}</p>
                </div>
                <div className="relative mt-4 overflow-x-auto overflow-x-auto shadow-md scrollbar scrollbar-track-gray-100 scrollbar-thumb-gray-300 scrollbar-track-rounded-full scrollbar-thumb-rounded-xl scrollbar-h-1.5 sm:rounded-lg">
                  {isLoading ? (
                    <DivLoader className="m-5 h-6 w-6 border-indigo-500" />
                  ) : (
                    <>
                      
                      <table className="w-full w-full text-left text-sm text-gray-500 dark:text-gray-400 rtl:text-right">
                        <thead className="bg-gray-50 text-xs uppercase text-gray-700 dark:bg-gray-700 dark:text-gray-400">
                          {table?.getHeaderGroups().map((headerGroup) => (
                            <tr
                              key={headerGroup.id}
                              className="!border-px !border-gray-400"
                            >
                              {headerGroup.headers?.map((header) => {
                                return (
                                  <th
                                    key={header.id}
                                    colSpan={header.colSpan}
                                    onClick={header.column.getCanSort() ? header.column.getToggleSortingHandler() : undefined}
                                    className={`border-b-[1px] border-gray-200 pb-2 pr-4 pt-4 text-start p-2 ${header.column.getCanSort() ? 'cursor-pointer' : ''}`}
                                  >
                                    <div className="flex items-center text-xs text-gray-200">
                                      
                                      {flexRender(header.column.columnDef.header, header.getContext())}
                            
                                      {header.column.getCanSort() && ( // Only show if sorting is enabled
                                        <span className="ml-2">
                                          {header.column.getIsSorted() === "asc" ? (
                                            <BsArrowUp size={14} className="text-gray-900" />
                                          ) : header.column.getIsSorted() === "desc" ? (
                                            <BsArrowDown size={14} className="text-gray-900" />
                                          ) : (
                                            <RiArrowUpDownFill size={14} className="text-gray-900" />
                                          )}
                                        </span>
                                      )}
                                    </div>
                                  </th>
                                );
                              })}
                            </tr>
                          ))}
                        </thead>
                        <tbody>
                          {table.getRowModel().rows?.length > 0 ? (
                            table.getRowModel().rows.map((row) => {
                              return (
                                <tr
                                  key={row.id}
                                  className={`border-b hover:bg-gray-50 dark:border-gray-700  dark:bg-gray-800 ${
                                    row.getIsExpanded() ? "" : ""
                                  } ${!row.getCanExpand() ? "" : ""} `}
                                >
                                  {row.getVisibleCells().map((cell) => {
                                    return (
                                      <td
                                        key={cell.id}
                                        className={`border-white/0 px-2 py-3`}
                                      >
                                        {flexRender(
                                          cell.column.columnDef.cell,
                                          cell.getContext()
                                        )}
                                      </td>
                                    );
                                  })}
                                </tr>
                              );
                            })
                          ) : (
                            <tr>
                              <td colSpan={10}>
                                <p className="p-4 text-center">
                                  No records found.
                                </p>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </>
                  )}
                </div>
              </div>

              
           
          </ModalBody>
          <ModalFooter className="mt-[10px]">
           <div className="mt-5  flex gap-2 px-[30px] pb-[30px]">
              <button
                onClick={handleClose}
                className="linear rounded-xl bg-indigo-600 px-5 py-2 text-white font-medium text-navy-700 outline-none transition duration-200 hover:bg-indigo-500 active:bg-indigo-500 dark:bg-white/10 dark:text-white dark:hover:bg-white/20 dark:active:bg-white/30"
                // className="linear rounded-xl bg-gray-100 px-5 py-2 text-base font-medium text-navy-700 outline-none transition duration-200 hover:bg-gray-200 active:bg-gray-300 dark:bg-white/10 dark:text-white dark:hover:bg-white/20 dark:active:bg-white/30"
              >
                Close
              </button>
            </div>
          </ModalFooter>
        </Card>  
        {/* </ModalContent> */}
      </Modal>
    </>
  );
};
export default ViewHistoryModal;
const columnHelper = createColumnHelper<any>();
